export const fontSizes = {
  $0: 12,
  $1: 13,
  $2: 14,
  $3: 16,
  $4: 20,
  $5: 24,
  $6: 28,
  $7: 32,
  $8: 48,
  $9: 60,
}

export const fontWeights = {
  thin: '300',
  body: '400',
  bold: '600',
  bolder: '700',
}